import { Navigate, createFileRoute } from '@tanstack/react-router';

import { ShigoPermission } from '../features/auth/permissions';
import { useShigoPermissions } from '../features/auth/useShigoPermissions';

export const Route = createFileRoute('/supply/ads-txt/')({ component: AdsTxtIndex });

function AdsTxtIndex() {
  const { can } = useShigoPermissions();
  let to: '/supply/ads-txt/apps' | '/supply/ads-txt/records' | '/supply/ads-txt/domains' =
    '/supply/ads-txt/domains';
  if (can(ShigoPermission.SupplyAdsTxtRecordsRead)) to = '/supply/ads-txt/records';
  if (can(ShigoPermission.SupplyAdsTxtAppsRead)) to = '/supply/ads-txt/apps';
  return <Navigate to={to} search={{}} replace />;
}
